<template>
    <v-dialog max-width="1200px" v-model="inDialog" persistent>
        <v-card>
            <v-form ref="createForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">Thông tin sữa chữa</v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <table class="lstTable">
                        <tr>
                            <th width="10%">Ngày xuất kho đi sửa</th>
                            <th width="10%">Ngày nhận</th>
                            <th width="15%">Đơn vị sửa chữa</th>
                            <th width="15%">Nộ dung sửa chữa</th>
                            <th width="10%">Chi phí sửa chữa</th>
                            <th width="10%">Bảo hành sửa chữa</th>
                            <th width="15%">Tình trạng sau sửa chữa</th>
                            <th width="15%">Ghi chú</th>
                        </tr>
                        <tr>
                            <td style="text-align:center">
                                <!-- <i-datepicker 
                                    v-model="item.repairDate"
                                    :minDate="minDate()"
                                /> -->
                                {{ item.repairDate }}
                            </td>
                            <td style="text-align:center">
                                <!-- <i-datepicker 
                                    v-model="item.receiveDate"
                                /> -->
                                {{ item.receiveDate }}
                            </td>
                            <td style="text-align:center">
                                <!-- <v-text-field
                                    type="text"
                                    label="Đơn vị sửa chữa"
                                    v-model.trim="item.repairUnit"
                                    name="repairUnit"
                                    maxLength="250"
                                ></v-text-field> -->
                                {{ item.repairUnitName != undefined ? item.repairUnitName : this.getSupplierName(item.repairUnit) }}
                            </td>
                            <td style="text-align:center">
                                <!-- <v-text-field
                                    type="text"
                                    label="Nội dung sửa chữa"
                                    v-model.trim="item.content"
                                    name="content"
                                    maxLength="250"
                                ></v-text-field> -->
                                {{ item.content }}
                            </td>
                            <td>
                                <v-text-field
                                    type="number"
                                    label="Chi phí sửa chữa"
                                    v-model.trim="item.repairCost"
                                    name="repairCost"
                                ></v-text-field>
                            </td>
                            <td>
                                <i-datepicker 
                                    v-model="item.repairWarranty"
                                />
                            </td>
                            <td>
                                <v-text-field
                                    type="text"
                                    label="Tình trạng sau sửa chữa"
                                    v-model.trim="item.receiveStatus"
                                    name="receiveStatus"
                                    maxLength="250"
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    type="text"
                                    label="Ghi chú"
                                    v-model.trim="item.note"
                                    name="note"
                                    maxLength="250"
                                ></v-text-field>
                            </td>
                        </tr>
                    </table>
                </v-card-text>
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.confirm") }}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { message } from "../../../services";
import axios from "axios";
import moment from "moment";

export default {
    name: "repair-create",
    components: { message, axios },
    props: {
        propsItem: {
            type: Object,
            default: () => {
                return {}
            }
        },
        lstSupplier: {
            type: Array,
            default: () => {
                return []
            }
        },
        cDialog: {
            type: Boolean,
            default: false,
        },
        fixedAssetsId: {
            type: Number,
            default: 0,
        },
        isImport: {
            type: Boolean,
            default: false,
        },
    },
    data: () => {
        return {
            inDialog: false,
            item: {
                fixedAssetsId: 0,
                repairDate: null,
                receiveDate: null,
                repairUnit: "",
                content: "",
                repairCost: "",
                repairWarranty: null,
                note: "",
                receiveStatus: "",
            },
        };
    },
    created() {
        // this.getSupplier();
    },
    computed:{
        
    },
    watch: {
        propsItem: {
            handler(value) {
                console.log(value);
                if (value !== null) {
                    if (value.expectedDateExport != undefined) {
                        this.item = {
                            id: '',
                            fixedAssetsId: value.fixedAssetsId,
                            repairDate: value.expectedDateExport,
                            receiveDate: moment().format('YYYY-MM-DD'),
                            repairUnit: value.repairUnitId,
                            content: value.repairContent,
                            repairCost: value.expectedCost,
                            repairWarranty: null,
                            note: '',
                            receiveStatus: '',
                            repairRequestId: value.repairRequestId,
                        };
                    } else {
                        this.item = value;
                    }
                } else {
                    this.resetFrom();
                }
            },
            deep: true,
        },
        cDialog(value) {
            this.inDialog = value;
        },
        fixedAssetsId(value) {
            this.item.fixedAssetsId = value;
        },
        inDialog (value) {
            if(!value){
                this.$emit("closeCreateDialog", "");
            }
        },
    },
    methods: {
        resetFrom: function () {
            this.item = {
                fixedAssetsId: this.fixedAssetsId,
                repairDate: null,
                receiveDate: null,
                repairUnit: "",
                content: "",
                repairCost: "",
                repairWarranty: null,
                note: "",
                receiveStatus: "",
            };
            this.$validator.reset();
        },
        onCancel: function (fixedAssetsId = null) {
            this.$emit("closeCreateDialog", fixedAssetsId);
        },
        onSave: function () {
            const self = this;
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/fixedAssetsRepair/save",
                        this.item
                    )
                    .then(
                        (data) => {
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.onCancel(this.item.fixedAssetsId);
                                this.resetFrom();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            });
        },
        minDate() {
            const minDate = moment().format('YYYY-MM-DD');
            return minDate;
        },
        // getSupplier() {
        //     axios.post(
        //         process.env.VUE_APP_API_URL + "/partner/search?pageSize=-1&page=-1&orderBy=asc",
        //         {}
        //     )
        //         .then(
        //             (data) => {
        //                 if (data.items) {
        //                     this.lstSupplier = data.items;
        //                 }
        //             }
        //         );
        // },
        getSupplierName(supplierId) {
            let partnerName = '';
            const partner = this.lstSupplier.find((v) => v.partnerId === supplierId);
            if (partner != undefined) {
                partnerName = partner.partnerName;
            }
            return partnerName;
        },
    },
    created() {},
};
</script>
